import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './BottomTable.module.scss';

export default function BottomTable({ perguntas, respostas }) {
  const {
    BottomTable,
    Row,
    Block,
    First,
    Last,
    Whitespot,
    Green,
    Yellow,
  } = Styles;

  let divCount = 0;
  const k = () => `bottomtable${++divCount}`;

  const green = (row, col) => [2, 3].includes(col) && (!row || row === 6);
  const yellow = (row, col) => [2, 3].includes(col) && row === 1;

  return (
    <div className={BottomTable}>
      <header>
        <div style={{ minWidth: '40%' }}>Item</div>
        <div>Recomendação SQM VITAS BRASIL</div>
        <div>Recomendação Convencional</div>
        <div> Diferença em valores / ha</div>
        <div>Diferença</div>
        <div>Diferenças em valores (Área total)</div>
      </header>
      <main>
        {perguntas.map((pergunta, index) => (
          <>
            <div key={k()} className={C(Row, [index === perguntas.length, Last])}>
              <div className={C(Block, First)}>{pergunta}</div>
              {respostas[index].map((x, y) => (
                <div
                  key={k()}
                  className={C(
                    Block,
                    [x === 'w', Whitespot],
                    [green(index, y), Green],
                    [yellow(index, y), Yellow],
                  )}
                  id={`pergunta_${index}_resposta_${y}`}
                >
                  {x !== 'w' && x}
                </div>
              ))}
            </div>
            {index === 2 ? <div className={Row} /> : null}
          </>
        ))}
      </main>
    </div>
  );
}

BottomTable.propTypes = {
  perguntas: PropTypes.array.isRequired,
  respostas: PropTypes.array.isRequired,
};
